import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { TRANSLATION_KEYS } from '@core/internationalization/translations_keys';
import { Check, LucideAngularModule, Sparkles } from 'lucide-angular';
import { BillingService } from '../../services/billing.service';

@Component({
    selector: 'app-trial-expired-modal',
    standalone: true,
    imports: [TranslatePipe, LucideAngularModule],
    templateUrl: './trial-expired-modal.component.html',
    styles: [
        `
            :host {
                display: contents;
            }
        `,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrialExpiredModalComponent {
    protected readonly KEYS = TRANSLATION_KEYS.settings.account.billing.trialExpired;
    protected readonly SparklesIcon = Sparkles;
    protected readonly CheckIcon = Check;
    private readonly billingS = inject(BillingService);

    protected readonly benefits = [
        this.KEYS.benefit1,
        this.KEYS.benefit2,
        this.KEYS.benefit3,
    ];

    protected readonly subscribe = () => {
        this.billingS.goToSubcribe();
    };
}
